module.exports = __webpack_public_path__ + "static/media/iodesign.4baa9953.jpg";